import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "targetJob", "preview", "previewImages"]
  static values = { images: Object }

  declare sourceTarget: HTMLSelectElement
  declare targetJobTargets: HTMLElement[]
  declare hasPreviewTarget: boolean
  declare previewTarget: HTMLElement
  declare hasPreviewImagesTarget: boolean
  declare previewImagesTarget: HTMLElement
  declare imagesValue: Record<string, string[]>

  sourceChanged() {
    const selectedId = this.sourceTarget.value
    this.targetJobTargets.forEach((el) => {
      const jobId = el.dataset.jobId
      if (jobId && jobId === selectedId) {
        el.style.display = "none"
        const checkbox = el.querySelector<HTMLInputElement>('input[type="checkbox"]')
        if (checkbox) checkbox.checked = false
      } else {
        el.style.display = ""
      }
    })

    if (this.hasPreviewTarget && this.hasPreviewImagesTarget) {
      const images = selectedId && this.imagesValue[selectedId]
      if (images && images.length > 0) {
        this.previewImagesTarget.innerHTML = images.map((src: string) =>
          `<img src="${src}" class="img-thumbnail" style="max-height: 60px; max-width: 140px;">`
        ).join("")
        this.previewTarget.style.display = ""
      } else {
        this.previewTarget.style.display = "none"
      }
    }
  }
}
